"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(selection) {
    var e_1, _a;
    var types = new Set();
    if (!selection) {
        return null;
    }
    if (selection._objects) {
        try {
            for (var _b = __values(selection._objects), _c = _b.next(); !_c.done; _c = _b.next()) {
                var object = _c.value;
                types.add(object.type);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else {
        types.add(selection.type);
    }
    var typesArray = Array.from(types);
    return typesArray;
}
exports.default = default_1;
//# sourceMappingURL=get-selection-type.js.map